import React from "react";

import RelatorioSaboresFiltersBlock from "../components/RelatorioSaboresFiltersBlock";
import RelatorioQueryErrorAlert from "../components/RelatorioQueryErrorAlert";
import RelatorioSaboresTableBlock from "../components/RelatorioSaboresTableBlock";
import { useRelatorioSabores } from "../context/RelatorioSaboresContext";
import PizzasPorSaborKpiStrip from "./PizzasPorSaborKpiStrip";
import PizzasPorSaborTamanhoSaborTable from "./PizzasPorSaborTamanhoSaborTable";
import PizzasPorSaborTop10Block from "./PizzasPorSaborTop10Block";
import PizzasPorSaborCharts from "./PizzasPorSaborCharts";

const PizzasPorSaborWorkspace: React.FC = () => {
  const { queryErrorMessage } = useRelatorioSabores();

  return (
    <div className="flex flex-col gap-10">
      <RelatorioSaboresFiltersBlock />
      {queryErrorMessage ? (
        <RelatorioQueryErrorAlert message={queryErrorMessage} />
      ) : (
        <>
          <PizzasPorSaborTamanhoSaborTable />
          <PizzasPorSaborTop10Block />
          <PizzasPorSaborKpiStrip />
          <PizzasPorSaborCharts />
          <RelatorioSaboresTableBlock />
        </>
      )}
    </div>
  );
};

export default PizzasPorSaborWorkspace;
